import { IonButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useHistory, useLocation, useParams } from 'react-router';
import { CustomRoutes } from '../../utils/CustomRoutes';
import ViewAllGlobalQuestions from '../../components/interview/ViewAllGlobalQuestions';
import LoginComponent from '../../components/common/LoginComponent';

const ViewAllGlobalQuestionsPage: React.FC = () => {
  const history = useHistory();
  const goToViewInterviews = () => {
    history.push(CustomRoutes.viewInterview);
  }
  let PageTitle = "All Global Questions"
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>
            {PageTitle}
          </IonTitle>
          <IonButtons slot='end'>
            <LoginComponent></LoginComponent>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar color="primary">
            <IonTitle size="large">{PageTitle}</IonTitle>
            {/* <IonButton>View Interviews</IonButton> */}
          </IonToolbar>
        </IonHeader>
        <ViewAllGlobalQuestions></ViewAllGlobalQuestions>
      </IonContent>
    </IonPage>
  );
};

export default ViewAllGlobalQuestionsPage;
